export default "__VITE_ASSET__4a59c837__"